<template>
  <v-layout wrap pb-12>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="50"
      is-full-screen
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-snackbar v-model="showsnackbar" color="#9eaade" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-flex>
      <v-card>
        <v-layout wrap justify-center>
          <v-flex xs12>
            <v-layout
              :justify-start="$vuetify.breakpoint.name !== 'xs' ? true : false"
              :justify-center="$vuetify.breakpoint.name == 'xs' ? true : false"
              wrap
              pt-6
            >
              <v-layout justify-center wrap>
                <v-flex xs3 sm3 md3 pl-5 text-center>
                  <v-img
                    width="30px"
                    src="./../../assets/images/subject.svg"
                  ></v-img>
                </v-flex>
                <v-flex xs9 sm9 md9 text-left>
                  <span
                    style="
                      font-family: nunitosansbold;
                      font-size: 20px;
                      color: #000000;
                    "
                    >Add Subject</span
                  >
                </v-flex>
              </v-layout>
              <v-flex xs6 sm6 md9 align-self-center>
                <router-link :to="'/viewSubject'" style="text-decoration: none">
                  <span
                    style="
                      color: #797979;
                      font-family: nunitosanssemibold;
                      font-size: 18px;
                    "
                    >View Subject</span
                  >
                </router-link>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-text>
            <v-layout justify-center wrap>
              <v-flex xs12 sm6 md6 pa-2>
                <v-select
                  v-model="standard"
                  dense
                  style="font-family: nunitosansregular"
                  :items="classArray"
                  item-text="standardName"
                  item-value="_id"
                  outlined
                  label="Class"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2>
                <v-text-field
                  style="font-family: nunitosansregular"
                  label="Subject Name"
                  outlined
                  dense
                  color="#000000"
                  v-model="subjectName"
                >
                </v-text-field>
              </v-flex>
              <v-layout justify-center wrap>
                <v-flex xs12 pa-2>
                  <span style="font-family: nunitosanssemibold"
                    >Please Select The Color</span
                  >
                </v-flex>
              </v-layout>
              <v-flex xs12 pa-2>
                <!-- <v-color-picker
                  dot-size="25"
                  hide-mode-switch
                  mode="hexa"
                  swatches-max-height="200"
                  v-model="color"
                ></v-color-picker> -->
                <v-color-picker mode="hexa" v-model="color"></v-color-picker>
              </v-flex>
              <!-- <v-layout justify-center wrap>
                <v-flex v-if="tot.length>0"
                  pb-2
                  xs12
                  pl-2
                  style="font-family: nunitosansregular; color: #9385ef">
                  Added Subjects
                </v-flex>
                <v-flex v-else
                  pb-2
                  xs12
                  pl-2
                  style="font-family: nunitosansregular; color: #9385ef">
                  No Subjects Added
                </v-flex>
                <v-flex xs12 pb-5 pl-2>
                  <v-chip
                    @mouseover="showByIndex = i"
                    @mouseout="showByIndex = null"
                    id="a"
                    color="#747474"
                    background="#9385ef"
                    outlined
                    class="ma-1"
                    v-for="(item, i) in tot"
                    :key="i"
                    style="margin-right: 1%; text-transform: uppercase">
                    <v-layout wrap>
                      <v-flex>
                        <span
                          style="
                            font-family: nunitosansregular;
                            font-size: 12px;">{{ item }}
                        </span>
                      </v-flex>
                      <v-flex v-show="showByIndex === i" align-self-center pl-2>
                        <v-icon @click="dlt(i)">mdi-close-circle</v-icon>
                      </v-flex>
                    </v-layout>
                  </v-chip>
                </v-flex>
              </v-layout> -->
            </v-layout>
            <v-layout justify-center wrap>
              <v-flex xs12 sm6 md4 text-center py-5>
                <v-btn block dark height="50px" color="#9385EF" @click="addAll">
                  <span style="font-family: nunitosanssemibold">SUBMIT</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-layout justify-center wrap>
            <v-flex xs12>
              <v-layout justify-center wrap>
                <v-layout justify-center wrap>
                  <v-flex xs12 class="dottedline"> </v-flex>
                </v-layout>
                <v-flex xs1>
                  <p class="text-center">or</p>
                </v-flex>
                <v-layout justify-center wrap>
                  <v-flex xs12 class="dottedline"> </v-flex>
                </v-layout>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-card-text>
            <v-layout justify-center wrap>
              <v-flex xs12 text-center v-if="file">
                <span>{{ file.name }}</span>
              </v-flex>
              <v-flex xs12 md4 offset-md4>
                <v-btn
                  block
                  small
                  dark
                  height="50px"
                  color="#9B8DFD"
                  @click="$refs.showFile.click()"
                >
                  <v-icon style="color: #ffffff">mdi-note-text-outline</v-icon>
                  <span style="font-family: nunitosanssemibold"
                    >UPLOAD SUBJECT LIST SHEET</span
                  >
                </v-btn>
                <input
                  v-show="false"
                  id="file"
                  ref="showFile"
                  multiple="multiple"
                  type="file"
                  @change="showFile"
                />
                <v-layout justify-center wrap pt-2>
                  <v-flex xs12 text-center>
                    <span style="font-family: nunitosansregular; color: #8f8f8f"
                      >Upload One or Multiple Subjects</span
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md4 py-2 text-right>
                <a
                  :href="'http://52.66.213.94/u/1625480490634.xlsx'"
                  style="text-decoration: none"
                >
                  <v-btn small plain color="#9B8DFD">
                    <span>Download Template</span>
                    <v-icon>mdi-download-outline</v-icon>
                  </v-btn>
                </a>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      ServerError: false,
      appLoading: false,
      showsnackbar: false,
      timeout: 5000,
      filePreview: false,
      showFilePreview: false,
      file: null,
      msg: "",
      subjectName: "",
      // color: "",
      tot: [],
      sub: [],
      standard: "",
      classArray: [],
      classid: "",
      showByIndex: null,
      types: ["hex"],
      type: "hex",
      hex: "#FF00FF",
    };
  },
  computed: {
    color: {
      get() {
        return this[this.type];
      },
      set(v) {
        this[this.type] = v;
      },
    },
    showColor() {
      if (typeof this.color === "string") return this.color;

      return JSON.stringify(
        Object.keys(this.color).reduce((color, key) => {
          color[key] = Number(this.color[key].toFixed(2));
          return color;
        }, {}),
        null,
        2
      );
    },
  },
  watch: {
    standard() {
      this.getSub();
    },
  },
  mounted() {
    this.getSub();
    this.getStandard();
  },
  methods: {
    showFile(e) {
      this.file = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.filePreview = e.target.result;
      };
      if (this.file.size > 2145728) {
        this.msg = "File Should be less than 2MB";
        this.showsnackbar = true;
        return;
      }
      this.showFilePreview = true;
      if (this.file) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
        this.uploadFile();
      }
    },
    uploadFile() {
      let formData = new FormData();
      formData.append("doc", this.file);
      axios({
        method: "POST",
        url: "/excelimport/subject/upload",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = "Uploaded Successully";
            this.showsnackbar = true;
            this.file = null;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getStandard() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/standard/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.classArray = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    add() {
      if (this.subject.length != "") {
        this.tot.push(this.subject);
        this.subject = "";
      } else {
        this.showsnackbar = true;
        this.msg = "Please insert something";
      }
    },
    dlt(value) {
      this.tot.splice(value, 1);
    },
    getSub() {
      this.appLoading = true;
      axios({
        url: "/standard/subject/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          standard: this.standard,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.tot = [];
            for (var i = 0; i < response.data.data.length; i++) {
              this.tot.push(response.data.data[i].subjectName);
            }
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    addAll() {
      this.appLoading = true;
      axios({
        method: "post",
        url: "/subject/standard/add",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          subjectName: this.subjectName,
          standard: this.standard,
          color: this.color,
        },
      }).then((response) => {
        if (response.data.status) {
          this.appLoading = false;
          this.showsnackbar = true;
          this.msg = "Succesfully Added Subject";
        } else {
          this.msg = response.data.msg;
          this.showsnackbar = true;
        }
      });
    },
  },
};
</script>
<style scoped>
#a :hover {
  /* background: #9385ef;
  color: white; */
  color: #9385ef;
}
#b:hover {
  color: black;

  transition: 0.5s;
}
#b {
  color: gray;
}
.dottedline {
  border: none;
  /* border-top: 1px dashed rgb(208, 208, 208); */
  color: #8f8f8f;
  /* text-align: center; */
  background-color: #8f8f8f;
  height: 1px;
  width: 100%;
}
</style>